import { gql } from "@apollo/client";

export const FETCH_CART = gql`
  query getCurrentCartItems($action_type: Int) {
    me {
      cashback
    }
    billing_hosting {
      carts {
        id
        qty
        user_id
        name
        status
        db
        package_extension_id
        package_pricing_id
        price
        package_pricing_duration(action_type: $action_type)
        package {
          id
          name
          status
        }
        vps_package_name
        cpanel
        promo_discount_preview
      }
    }
  }
`;

export const CREATE_CART_DOMAIN = gql`
  mutation createCartDomain($input: NewCart!) {
    billing {
      cartOps {
        createCartDomain(input: $input) {
          id
          qty
          user_id
          name
          status
          db
          package_extension_id
          package_pricing_id
          price
          package_pricing_duration
          package {
            id
            name
            status
          }
          vps_package_name
          cpanel
        }
      }
    }
  }
`;

export const CREATE_CART_HOSTING = gql`
  mutation createCart($input: CreateCartHosting!) {
    billing {
      cartOps {
        createCartHosting(input: $input) {
          id
          qty
          user_id
          name
          status
          db
          package_extension_id
          package_pricing_id
          price
          package_pricing_duration
          package {
            id
            name
            status
          }
          vps_package_name
          cpanel
        }
      }
    }
  }
`;

export const CREATE_CART_DOMAIN_BATCH = gql`
  mutation createCartDomain($input: [NewCart!]!) {
    billing {
      cartOps {
        create_cart_domain_batch(input: $input) {
          id
          qty
          user_id
          name
          status
          db
          package_extension_id
          package_pricing_id
          price
          package_pricing_duration
          package {
            id
            name
            status
          }
        }
      }
    }
  }
`;

export const CREATE_CART_HOSTING_BATCH = gql`
  mutation createCartDomain($input: [CreateCartHosting!]!) {
    billing {
      cartOps {
        create_cart_hosting_batch(input: $input) {
          id
          qty
          user_id
          name
          status
          db
          package_extension_id
          package_pricing_id
          price
          package_pricing_duration
          package {
            id
            name
            status
          }
        }
      }
    }
  }
`;

export const CHECKOUT_CART = gql`
  mutation ($cart_ids: [Int!]!, $voucher_code: String, $use_cashback: Boolean) {
    billing {
      cartOps {
        cartCheckout(cart_ids: $cart_ids, voucher_code: $voucher_code, use_cashback: $use_cashback)
      }
    }
  }
`;

export const UPDATE_CART = gql`
  mutation updateCart($id: ID!, $qty: String!) {
    billing {
      cartOps {
        updateCart(input: { id: $id, qty: $qty }) {
          id
          qty
          user_id
          name
          status
          db
          package_extension_id
          package_pricing_id
          price
          package_pricing_duration
          package {
            id
            name
            status
          }
          vps_package_name
          cpanel
          promo_discount_preview
        }
      }
    }
  }
`;

export const DELETE_CART = gql`
  mutation deleteCart($id: Int!) {
    billing {
      cartOps {
        deleteCart(id: $id)
      }
    }
  }
`;

export const CHECK_DOMAIN_BATCH = gql`
  mutation ($domain: [String!]!) {
    domain {
      domainOps {
        check_domain_batch(domain: $domain) {
          code
          domain
          available
          reason
          premium
        }
      }
    }
  }
`;

export const UPDATE_UPLOAD_PROOF = gql`
  mutation ($id: Int!, $status: Int!) {
    billing {
      transactionOps {
        updateTransactionUploadedStatus(id: $id, status: $status)
      }
    }
  }
`;
